import { getDevices } from "./endpoints";
/*
const getDevicesByCompany = async (token) => {
  try {
    const data = await getDevices(token);

    return data.map((device, index) => ({
      ...device,
      id: device.id || `device-${index}`,
    }));
  } catch (error) {
    console.error("Failed to fetch devices:", error);
    throw error; 
  }
};

export default getDevicesByCompany;
*/


const getDevicesByCompany = async (token, company) => {
  try {
    const data = await getDevices(token, company);

    return data.map((device, index) => ({
      ...device,
      id: device.id || `device-${index}`,
    }));
  } catch (error) {
    console.error("Failed to fetch devices:", error);
    throw error;
  }
};

export default getDevicesByCompany;
